import { Store, Module, ActionContext } from 'vuex'
import ListModule from './list-module'
import ListState from './list-state'
import Ajax from '../../lib/ajax'
import PageResult from '@/store/entities/page-result';
import ListMutations from './list-mutations'
import OrderFontList from '../entities/order-font-list'
import createdata from '@/store/entities/create-order'
import ResultModel from '@/store/entities/nationalLogisticsInfo'
import appconst from '@/lib/appconst';
import UserOrderStatistics from '@/store/entities/user-order-statistics';


interface FontOrderState extends ListState<OrderFontList> {
    orderInfo: createdata,

}

class FontOrderMutations extends ListMutations<OrderFontList>{

}
class FontOrder extends ListModule<FontOrderState, any, OrderFontList>{
    state = {
        totalCount: 0,
        currentPage: 1,
        pageSize: 10,
        list: new Array<OrderFontList>(),
        loading: false,
        orderInfo: new createdata(),
        orderStatus: null,
    }
    actions = {
        async getAll(context: ActionContext<FontOrderState, any>, payload: any) {
            context.state.loading = true;
            let reponse = await Ajax.get('/api/services/app/FrontOrder/GetOrderList', { params: payload.data });
            context.state.loading = false;
            let page = reponse.data.result as PageResult<OrderFontList>;
            context.state.totalCount = page.totalCount;
            context.state.list = page.items;
        },
        async createOrder(state: any, payload: any) {
            let rep = await Ajax.post('/api/services/app/FrontOrder/CreateOrder', payload.data);
        },
        async updateOrder(state: any, payload: any) {
            let rep = await Ajax.post('/api/services/app/FrontOrder/UpdateOrder', payload.data);
        },
        async cancelOrder(state: any, payload: any) {
            let rep = await Ajax.post('/api/services/app/FrontOrder/CancelOrder?id=' + payload.data.id);
        },
        async supplyFreight(state: any, payload: any) {
            let rep = await Ajax.post('/api/services/app/FrontOrder/SupplyOrderFreight?id=' + payload.data.id);
        },
        async normalOrder(state: any, payload: any) {
            let rep = await Ajax.post('/api/services/app/FrontOrder/NormalOrder?id=' + payload.data.id);
        },
        async getOrder(context: ActionContext<FontOrderState, any>, payload: any) {
            let reponse = await Ajax.get('/api/services/app/FrontOrder/GetOrderInfo', { params: payload.data });
            context.state.orderInfo = (reponse.data.result as createdata);
        },
        async getOrderStatistics(state: any, payload: any) {
            let rep = await Ajax.get('/api/services/app/FrontOrder/GetOrderStatistics', payload.data);
            return rep.data.result as UserOrderStatistics;
        },
        async getResult(state: any, payload: any) {
            let rep = await Ajax.post('/api/services/app/FrontOrder/GetSearchResult?number=' + payload.data.number);
            return rep.data.result as ResultModel;
        },
        async impotExcel(state: any, payload: any) {
            Ajax.get('/api/File/GetFrontExpressExportMainlandOrderInfo', { params: payload.data, responseType: "blob" }).then(res => {
                const content = res.data;
                const blob = new Blob([content]);
                const fileName = '本土订单信息.xlsx'
                if ('download' in document.createElement('a')) { // 非IE下载
                    const elink = document.createElement('a')
                    elink.download = fileName
                    elink.style.display = 'none'
                    elink.href = URL.createObjectURL(blob)
                    document.body.appendChild(elink)
                    elink.click()
                    URL.revokeObjectURL(elink.href) // 释放URL 对象
                    document.body.removeChild(elink)
                }
            });
        },
    };
    mutations = {
        setCurrentPage(state: FontOrderState, page: number) {
            state.currentPage = page;
        },
        setPageSize(state: FontOrderState, pagesize: number) {
            state.pageSize = pagesize;
        },
        getPdf(state: FontOrderState, data: any) {
            if (data.pdfGuid && data.pdfGuid.length > 1) {
                window.open(appconst.remoteServiceBaseUrl + "api/File/GetPdf?guid=" + data.pdfGuid + "&id=" + (data.userId ? data.userId : abp.session.userId) + "&orderNumber=" + data.orderNumber);
            }
        },
        getPdfUrl(state: FontOrderState, data: any) {
            if (data.pdfGuid && data.pdfGuid.length > 1) {
                data.url = appconst.remoteServiceBaseUrl + "api/File/GetPdf?guid=" + data.pdfGuid + "&id=" + (data.userId ? data.userId : abp.session.userId) + "&orderNumber=" + data.orderNumber;
            } else {
                data.url = '';
            }
        }
    }
}

const fontMainLandOrder = new FontOrder();
export default fontMainLandOrder;